const required = (value) => {
    //console.log('in required',value);

    if(value.trim() === ''){
        return false;
    }
    return true;
}
const minLength = (value) => {
    //console.log('in min lenngth',value)
    return false;
}
const maxLength = (value) => {
   // console.log('in max lenngth',value)
    return false;
}
const checkNumber = (value) => {
    if(value !== null && value !== "" && !Number.isInteger(value)) {
        return true;
    }
    return false;
}
const validIndex = (value) => {
    if(value != null && value >= 0) {
        return true;
    }
    return false;
}

export const Validators = {
    required,
    minLength,
    maxLength,
    checkNumber,
    validIndex
}